import { IState } from '../../../store';
import { TOfferType } from '@cian/api-models/offer-card/v1/get-offer-data';

export const selectOfferType = (state: IState): TOfferType => state.offerData.offer.offerType;
